/**
 * Renders pre-generated editorial content stored in the database.
 * Content is server-generated HTML and rendered as static DOM for SEO crawlers.
 */
const EditorialEnrichment = ({ content }: { content: string | null }) => {
  if (!content) return null;

  return (
    <section className="py-12 px-4">
      <div className="max-w-3xl mx-auto">
        <div
          className="prose prose-invert prose-sm sm:prose-base max-w-none
            prose-h2:text-xl prose-h2:font-bold prose-h2:text-foreground prose-h2:mt-8 prose-h2:mb-4
            prose-p:text-muted-foreground prose-p:leading-relaxed
            prose-strong:text-foreground
            prose-li:text-muted-foreground
            prose-ul:space-y-3"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </div>
    </section>
  );
};

export default EditorialEnrichment;
